var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.pageId)?_c('render-page',{attrs:{"project-id":_vm.projectId,"page-id":_vm.pageId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }